const style = (theme) => {
  const output = {
    root: {
      height: 'var(--vh)',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    hero: {
      width: '50%',
    },
    overflowHidden: {
      overflow: 'hidden',
    },
    y0: {
      transform: 'translateY(0%) !important',
    },
    scrollDown: {
      position: 'absolute',
      bottom: 0,
      left: '4.15vw',
      opacity: 0,
      pointerEvents: 'none',
      transition: 'all 1s 1s ease',
      transform: 'translateX(-50%)',
    },
    scrollDownVisible: {
      opacity: 1,
      pointerEvents: 'all',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      height: 'var(--vh-fixed)',
    },
    hero: {
      width: '100%',
    },
    scrollDown: {
      left: 30,
      transform: 'translateX(0%)',
    },
  }

  return output
}

export default style
